import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { ChevronIcon } from '@sainsburys-tech/bolt-icons'
import * as Styled from './MediaGalleryGrid.styles'

const MEDIA_ITEMS_THRESHOLD = 7

const MediaGalleryGrid = props => {
  const { media, dataTest } = props
  const [showAllMedia, setShowAllMedia] = useState(false)

  return (
    media.length > 0 && (
      <Styled.MediaGalleryGridContainer data-test={dataTest}>
        <Styled.Row row='xs' gutterValue={0}>
          {media?.map((mediaItem, index) => {
            return (
              (index < MEDIA_ITEMS_THRESHOLD || showAllMedia) && (
                <Styled.Column
                  xs={12}
                  md={index === 0 ? 12 : 6}
                  key={index}
                  data-test='component-media-gallery-grid-column'
                >
                  {mediaItem}
                  {/* {index === 0 && syteButton} */}
                </Styled.Column>
              )
            )
          })}
        </Styled.Row>
        {media.length > MEDIA_ITEMS_THRESHOLD && !showAllMedia && (
          <Styled.Button
            kind='secondary'
            onClick={() => setShowAllMedia(prev => !prev)}
            data-test='component-media-gallery-grid-show-more-button'
            aria-label='Show more media items'
          >
            <ChevronIcon dir='down' />
            Show more
          </Styled.Button>
        )}
      </Styled.MediaGalleryGridContainer>
    )
  )
}

MediaGalleryGrid.propTypes = {
  media: PropTypes.arrayOf(PropTypes.element).isRequired,
  dataTest: PropTypes.string
}

MediaGalleryGrid.defaultProps = {
  dataTest: 'component-media-gallery-grid'
}

export default MediaGalleryGrid
